import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Locale = 'de' | 'en';

interface LocaleState {
  locale: Locale;
}

interface LocaleActions {
  setLocale: (locale: Locale) => void;
}

export const useLocaleStore = create<LocaleState & LocaleActions>()(
  persist(
    // English default (user call 2026-07-04 — overrides the earlier German-first
    // default); the toggle in the top bar / Settings / Login switches per user.
    (set) => ({
      locale: 'en',
      setLocale: (locale) => set({ locale }),
    }),
    {
      name: 'xantory:locale',
      onRehydrateStorage: () => (state) => {
        if (!state) return;
        if (state.locale !== 'de' && state.locale !== 'en') {
          state.locale = 'en';
        }
      },
    },
  ),
);
